export default __webpack_public_path__ + "static/media/Submitmg.c5d87a72.svg";